/**
 * L2-S5: moved verbatim out of
 * `@records/records-search/records-details/tim-availability-reports/tim-availability.constants`,
 * which now re-exports it.
 *
 * `TreeDataRowComponent` calls this from its cell-click handler, and that component moved into this
 * library. The function itself has ZERO records coupling — it is a `window.open` over two fields of
 * the clicked row — so relocating it is preferable to threading a navigate callback through the
 * table's `CommandSet`, which would have changed the public binding surface of a component four
 * host features and the reports remote already render.
 */
export function navigateToEntity({ entityname, associatedEntityId }): void {
  const entityName = entityname ? entityname.toLowerCase() : 'tim';
  window.open(`/records/${entityName}/${associatedEntityId}/edit`);
}
